export class InfoTecnicaBienMueble {
    alto: string
    ancho: string
    largo: string
    Grosor : string
    Diametro: string
    area: number
    profundidad: string
    Servicio: string
    Valor: string
    material: string
    tecnica: string
    utileria: string
    
}
